"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = require("react");

var _useParcelSideEffectSync = _interopRequireDefault(require("./useParcelSideEffectSync"));

var _dataparcels = _interopRequireDefault(require("dataparcels"));

var _cancel = _interopRequireDefault(require("dataparcels/cancel"));

var _ApplyBeforeChange = _interopRequireDefault(require("./util/ApplyBeforeChange")); // $FlowFixMe - useState is a named export of react
// $FlowFixMe - useState is a named export of react


var _default = function _default(params) {
  var valueUpdater = typeof params.value === "function" ? params.value : function () {
    return params.value;
  };
  var control = {}; // takes a parcel and chains the beforeChange functions off of it
  // placing them each inside .modifyUp()s
  // so that all changes made to the returned parcel
  // go up through all of beforeChange's functions

  var applyBeforeChange = (0, _ApplyBeforeChange["default"])(params.beforeChange); // if value is asyncValue, make valueUpdater() call the asyncValue

  var parcelRef = (0, _react.useRef)();

  if (valueUpdater._asyncValue) {
    var useAsyncValue = valueUpdater; // $FlowFixMe - useAsyncValue expects different arguments than valueUpdater

    var _useAsyncValue = useAsyncValue(function (newValue) {
      parcelRef.current.pipe(applyBeforeChange).set(newValue);
    }),
        _useAsyncValue2 = (0, _slicedToArray2["default"])(_useAsyncValue, 2),
        asyncGetValue = _useAsyncValue2[0],
        valueStatus = _useAsyncValue2[1];

    valueUpdater = asyncGetValue;
    control.valueStatus = valueStatus;
  } // store parcel in state


  var _useState = (0, _react.useState)(function () {
    var parcel = new _dataparcels["default"]({
      handleChange: function handleChange(parcel, changeRequest) {
        // remember the origin of the last change
        // useParcelBufferInternalKeepValue needs it
        parcel._frameMeta.lastOriginId = changeRequest.originId;
        setParcel(parcel);
      }
    });
    return parcel._changeAndReturn(function (parcel) {
      return parcel.pipe(applyBeforeChange).update(valueUpdater);
    })[0];
  }),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      parcel = _useState2[0],
      setParcel = _useState2[1];

  parcelRef.current = parcel; // use the updateValue param to set value from props

  if (params.updateValue) {
    parcel.modifyUp(function (value, changeRequest) {
      return changeRequest.hasDataChanged() ? value : _cancel["default"];
    }).pipe(applyBeforeChange).update(valueUpdater);
  } // use the rebase param


  if (params.rebase) {
    parcel._frameMeta.rebase = true;
  } // add the onChange handling logic to the parcel


  if (params.onChange) {
    var _ref = params.onChange.sideEffectHook ? params.onChange.sideEffectHook({
      parcel: parcel,
      onSideEffectUseResult: !!params.onChangeUseResult
    }) : (0, _useParcelSideEffectSync["default"])({
      parcel: parcel,
      onSideEffect: params.onChange,
      onSideEffectUseResult: !!params.onChangeUseResult
    }),
        _ref2 = (0, _slicedToArray2["default"])(_ref, 2),
        parcelWithOnChange = _ref2[0],
        changeStatus = _ref2[1];

    parcel = parcelWithOnChange;

    if (changeStatus) {
      control.changeStatus = changeStatus;
    }
  } // add the beforeChange logic to the parcel


  parcel = parcel.pipe(applyBeforeChange); // return the parcel

  return [parcel, control];
};

exports["default"] = _default;